/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { useState } from "react";
import * as Yup from "yup";
import clsx from "clsx";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import { getUserByToken, login } from "../core/_requests";
import { useAuth } from "../core/Auth";
import { toastfy } from "../../../../_metronic/partials/toast/Toast";
import { useIntl } from "react-intl";

export function Login() {
  const intl = useIntl();
  const [loading, setLoading] = useState(false);
  const { saveAuth, setCurrentUser } = useAuth();

  const loginSchema = Yup.object().shape({
    email: Yup.string()
      .email(intl.formatMessage({ id: "LOGINPAGE.LOGIN.EMAIL.INVALID_FORMAT" }))
      .min(
        3,
        intl.formatMessage({ id: "LOGINPAGE.LOGIN.EMAIL.MIN_CHARACTERS" })
      )
      .max(
        50,
        intl.formatMessage({ id: "LOGINPAGE.LOGIN.EMAIL.MAX_CHARACTERS" })
      )
      .required(intl.formatMessage({ id: "LOGINPAGE.LOGIN.EMAIL.REQUIRED" })),
    password: Yup.string()
      .min(
        3,
        intl.formatMessage({ id: "LOGINPAGE.LOGIN.PASSWORD.MIN_CHARACTERS" })
      )
      .max(
        50,
        intl.formatMessage({ id: "LOGINPAGE.LOGIN.PASSWORD.MAX_CHARACTERS" })
      )
      .required(
        intl.formatMessage({ id: "LOGINPAGE.LOGIN.PASSWORD.REQUIRED" })
      ),
  });

  const initialValues = {
    email: "santos.wagner@outlook.com",
    password: "111111",
  };

  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      setLoading(true);
      try {
        const { data: auth } = await login(values.email, values.password);
        saveAuth(auth);

        const { data: user } = await getUserByToken(auth.api_token);
        setCurrentUser(user);

        if (user.id) {
          toastfy(
            "success",
            intl.formatMessage({ id: "LOGINPAGE.LOGIN.SUCCESS" })
          );
        } else {
          toastfy(
            "warning",
            intl.formatMessage({ id: "LOGINPAGE.LOGIN.FAILURE" })
          );
        }
      } catch (error: any) {
        const errorMessage = error?.response?.data?.error;
        const errorStatus = error?.response?.status;
        const httpStatusCodeRegex = /^4\d{2}$/;
        const isWarningStatus = httpStatusCodeRegex.test(String(errorStatus));

        if (isWarningStatus) {
          toastfy("warning", errorMessage);
        } else {
          toastfy("error", errorMessage);
        }

        saveAuth(undefined);
        setStatus(
          intl.formatMessage({ id: "LOGINPAGE.LOGIN.INCORRECT_DETAILS" })
        );
        setSubmitting(false);
        setLoading(false);
      }
    },
  });

  return (
    <form
      className="form w-100"
      onSubmit={formik.handleSubmit}
      noValidate
      id="kt_login_signin_form"
    >
      {/* begin::Heading */}
      <div className="text-center mb-11">
        <h1 className="text-dark fw-bolder mb-3">
          {intl.formatMessage({
            id: "LOGINPAGE.LOGIN.CONECTION",
          })}
        </h1>
        {/* <div className='text-gray-500 fw-semibold fs-6'>Your Social Campaigns</div> */}
      </div>
      {/* begin::Heading */}

      {/* begin::Login options */}

      {/* end::Login options */}

      {/* begin::Separator */}
      {/* <div className='separator separator-content my-14'>
        <span className='w-125px text-gray-500 fw-semibold fs-7'>Or with email</span>
      </div> */}
      {/* end::Separator */}

      {/* {formik.status ? (
        <div className='mb-lg-15 alert alert-danger'>
          <div className='alert-text font-weight-bold'>{formik.status}</div>
        </div>
      ) : (
        <div className='mb-10 bg-light-info p-8 rounded'>
          <div className='text-info'>
            Use account <strong>admin@demo.com</strong> and password <strong>demo</strong> to
            continue.
          </div>
        </div>
      )} */}

      {/* begin::Form group */}
      <div className="fv-row mb-8">
        <label className="form-label fs-6 fw-bolder text-dark">
          {intl.formatMessage({
            id: "LOGINPAGE.LOGIN.EMAIL",
          })}
        </label>
        <input
          placeholder="Email"
          {...formik.getFieldProps("email")}
          className={clsx(
            "form-control bg-transparent",
            { "is-invalid": formik.touched.email && formik.errors.email },
            { "is-valid": formik.touched.email && !formik.errors.email }
          )}
          type="email"
          name="email"
          autoComplete="off"
        />
        {formik.touched.email && formik.errors.email && (
          <div className="fv-plugins-message-container">
            <span role="alert">{formik.errors.email}</span>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group */}
      <div className="fv-row mb-3">
        <label className="form-label fw-bolder text-dark fs-6 mb-0">
          {intl.formatMessage({
            id: "LOGINPAGE.LOGIN.PASSWORD",
          })}
        </label>
        <input
          type="password"
          placeholder="******"
          autoComplete="off"
          {...formik.getFieldProps("password")}
          className={clsx(
            "form-control bg-transparent",
            {
              "is-invalid": formik.touched.password && formik.errors.password,
            },
            {
              "is-valid": formik.touched.password && !formik.errors.password,
            }
          )}
        />
        {formik.touched.password && formik.errors.password && (
          <div className="fv-plugins-message-container">
            <div className="fv-help-block">
              <span role="alert">{formik.errors.password}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Wrapper */}
      <div className="d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-8">
        <div />

        {/* begin::Link */}
        <Link to="/auth/forgot-password" className="link-primary">
          {intl.formatMessage({
            id: "LOGINPAGE.LOGIN.FORGOTPASSWORD",
          })}
        </Link>
        {/* end::Link */}
      </div>
      {/* end::Wrapper */}

      {/* begin::Action */}
      <div className="d-grid mb-10">
        <button
          type="submit"
          id="kt_sign_in_submit"
          className="btn btn-primary"
          disabled={formik.isSubmitting || !formik.isValid}
        >
          {!loading && (
            <span className="indicator-label">
              {intl.formatMessage({
                id: "LOGINPAGE.LOGIN.CONTINUE",
              })}
            </span>
          )}
          {loading && (
            <span className="indicator-progress" style={{ display: "block" }}>
              {intl.formatMessage({
                id: "LOGINPAGE.LOGIN.WAIT",
              })}
              <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
            </span>
          )}
        </button>
      </div>
      {/* end::Action */}

      {/* <div className='text-gray-500 text-center fw-semibold fs-6'>
        Ainda não tem uma conta?{' '}
        <Link to='/auth/registration' className='link-primary'>
          Cadastre-se
        </Link>
      </div> */}
    </form>
  );
}
